import { Injectable } from '@angular/core';
import { Invoice } from '../entities/invoice.entity';
import { InvoiceActionRule } from '../models/invoice-action-rule.model';
import { INVOICE_STATUS_ACTION_CONFIG } from './invoice-status-action.config';
import { InvoiceAction } from '../enums/invoice-action.enum';

@Injectable()
export class GetInvoiceActionRulesUseCase {
  execute(invoice: Invoice): readonly InvoiceActionRule[] {
    const actions = INVOICE_STATUS_ACTION_CONFIG[invoice.status].actions;

    return actions.map((rule) => {
      if (rule.action === InvoiceAction.Cancel) {
        return { ...rule, enabled: rule.enabled && invoice.canCancel };
      }

      return rule;
    });
  }
}

